import { useTranslation } from 'react-i18next';
import { ProductInterface } from '../../services/exports/Interfaces';

type MenuItemAllergensProps = {
  product: ProductInterface;
  className?: string;
};

const AllergensList = (props: MenuItemAllergensProps) => {
  const { product, className } = props;
  const { t } = useTranslation(null, { keyPrefix: 'Shared:Allergens' });

  return (
    <>
      <div className={className}>
        <div className="flex flex-col gap-xs lg:px-lg px-md py-sm bg-gray">
          <h6>{t('title')}</h6>
        </div>
        <div className="lg:px-lg px-md py-sm space-y-1">
          <p className="text-sm text-brand-text-secondary">{t('description', { product: product.name })}</p>
          <div>
            <ul className="text-sm text-brand-text-secondary list-disc list-inside">
              {product.allergens?.map((allergen) => (
                <li key={allergen}>{t(`options.${allergen}`, { defaultValue: allergen })}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllergensList;
